import styles from "./style.module.scss";
import FlexibleRoom from "src/assets/flexible-room.jpg";

export const FlexibleSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h3>
          Flexible room <span>-2Fフレキシブルルーム-</span>
          <div className={styles.border} />
        </h3>
        <div className={styles.imageBox}>
          <img src={FlexibleRoom} alt="flexible-room" />
        </div>
        <div className={styles.grayBox} />
        <div className={styles.whiteBox}>
          <p>
            2階は1階と空間が完全に分かれており、少し静かな場でゆったり過ごしたい時におすすめ。布団は奥の寝室にまとめて並べる、部屋を分けて並べるなど自由にアレンジ可能。洗面所、お風呂、洗濯機がすべて2階にあるので、1階との使い分けがしやすくなっています。
          </p>
        </div>
      </div>
    </section>
  );
};
